var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2903_181820)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2956 8.29363C11.4831 8.10616 11.7374 8.00085 12.0026 8.00085C12.2678 8.00085 12.5221 8.10616 12.7096 8.29363L18.3666 13.9506C18.4621 14.0429 18.5383 14.1532 18.5907 14.2752C18.6431 14.3972 18.6707 14.5285 18.6718 14.6612C18.673 14.794 18.6477 14.9257 18.5974 15.0486C18.5471 15.1715 18.4729 15.2831 18.379 15.377C18.2851 15.4709 18.1734 15.5452 18.0505 15.5955C17.9276 15.6457 17.796 15.671 17.6632 15.6699C17.5304 15.6687 17.3992 15.6411 17.2772 15.5887C17.1552 15.5363 17.0448 15.4601 16.9526 15.3646L12.0026 10.4146L7.05259 15.3646C6.86398 15.5468 6.61138 15.6476 6.34919 15.6453C6.08699 15.643 5.83618 15.5379 5.65077 15.3525C5.46536 15.167 5.36019 14.9162 5.35791 14.654C5.35563 14.3918 5.45643 14.1392 5.63859 13.9506L11.2956 8.29363Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2903_181820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 -1 24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/arrowup.3b86ef969f8464e0c8ea31a92b6da081.svg";
export { ForwardRef as ReactComponent };